import { Grid, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { alertService } from '../../services/alert-service'
import { DateUtilService } from '../../services/date-util-service'
import CryptoJS from 'crypto-js'
import { EncKeys } from '../../../config'

const VTap = (props) => {
    const paymentData = useSelector((state) => state.customerData)
    const [userData, setUserData] = useState({
        accountNumber: '',
        Passcode: '',
        EnteredOTP: '',
    })
    const handleChange = ({ target: { name, value } }) => {
        let temp = { ...userData }
        temp[name] = value
        setUserData(temp)
    }
    const handleBack = () => {
        props.onBackBtnClick()
    }

    const postData = (action) => {
        const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
        const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)

        if (
            action === 'Submit' &&
            (userData.accountNumber !== props.creditLimit.CreditAccountNo ||
                userData.Passcode !== props.creditLimit.Passcode)
        ) {
            alertService.addError(
                'Credit Account Number or Passcode does not match with Customer ' +
                    paymentData.customerData.PaymentRequest.Uid
            )
            return false
        }

        const SubmissionDetails = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'v2p',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            OrderNo: paymentData.customerData.PaymentRequest.OrderNo,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
            Vid: paymentData.customerData.PaymentRequest.Vid,
            AccountNumber: props.creditLimit.CreditAccountNo,
            Passcode: props.creditLimit.Passcode,
            PhoneNo: props.creditLimit.Phone,
            Email: props.creditLimit.Email,
            CustomerId: props.creditLimit.CustomerId,
            Action: action,
            Code: action === 'Verify Code' ? userData.EnteredOTP : '',
            CustomerCode: paymentData.customerData.PaymentRequest.Uid,
        }
        const jsonBody = JSON.stringify(SubmissionDetails)

        let encryptedToken = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        props.handleSubmitBtn(encryptedToken.toString())
    }

    return (
        <>
            {props.showVtapOTP === false ? (
                <>
                    {' '}
                    <div style={{ padding: 10 }}>
                        <Typography>
                            Available Limit:{' '}
                            {DateUtilService.formatToCurrency(
                                props.creditLimit.Limit
                            )}
                        </Typography>
                        <ValidatorForm onSubmit={() => postData('Submit')}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6}>
                                    <TextValidator
                                        autoComplete="off"
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        onChange={handleChange}
                                        name="accountNumber"
                                        label="Account Number"
                                        value={userData.accountNumber}
                                        validators={['required']}
                                        errorMessages={[
                                            'Account Number is required',
                                        ]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextValidator
                                        autoComplete="off"
                                        fullWidth
                                        onInput={(e) => {
                                            e.target.value = e.target.value
                                                .toString()
                                                .slice(0, 10)
                                        }}
                                        label="Pass Code"
                                        size="small"
                                        variant="outlined"
                                        margin="normal"
                                        onChange={handleChange}
                                        name="Passcode"
                                        value={userData.Passcode}
                                        validators={['required']}
                                        errorMessages={[
                                            'Pass Code is required',
                                        ]}
                                    />
                                </Grid>
                            </Grid>
                            <br />

                            <br />
                            <Grid container spacing={1}>
                                <Grid item xs={12} md={6}>
                                    <button
                                        onClick={handleBack}
                                        className="backButton"
                                        style={{
                                            width: '100%',
                                            padding: '15px',
                                            fontSize: '15px',
                                        }}
                                    >
                                        Back
                                    </button>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <button
                                        type="submit"
                                        className="btn"
                                        style={{
                                            width: '100%',
                                            backgroundColor:
                                                paymentData.customerData
                                                    .UIConfig
                                                    .ButtonBackgroundColor,
                                            color: paymentData.customerData
                                                .UIConfig.ButtonTextColor,
                                        }}
                                    >
                                        Pay
                                    </button>
                                </Grid>
                            </Grid>
                        </ValidatorForm>
                    </div>
                </>
            ) : (
                <div style={{ padding: 10 }}>
                    <ValidatorForm onSubmit={() => postData('Verify Code')}>
                        <Typography>Please Enter OTP</Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>
                                <TextValidator
                                    autoComplete="off"
                                    fullWidth
                                    size="small"
                                    variant="outlined"
                                    margin="normal"
                                    onChange={handleChange}
                                    name="EnteredOTP"
                                    label="OTP"
                                    value={userData.EnteredOTP}
                                    validators={['required']}
                                    errorMessages={['OTP is required']}
                                />
                            </Grid>
                        </Grid>
                        <br />

                        <br />
                        <Grid container spacing={1}>
                             <Grid item xs={4} md={4}>
                                <button
                                    type="submit"
                                    className="btn"
                                    style={{
                                        width: '100%',
                                        backgroundColor:
                                            paymentData.customerData.UIConfig
                                                .ButtonBackgroundColor,
                                        color: paymentData.customerData.UIConfig
                                            .ButtonTextColor,
                                    }}
                                >
                                    Verify
                                </button>
                            </Grid>
                             <Grid item xs={4} sm={4}>
                                <button
                                    onClick={() => postData('Resend')}
                                    className="backButton"
                                    style={{
                                        width: '100%',
                                        paddingLeft: '14px',
                                        paddingRight: '14px',
                                        paddingTop: '16px',
                                        paddingBottom: '16px',
                                        fontSize: '15px',
                                        backgroundColor: '#ff9200',
                                        marginBottom: '-10px',
                                        color: 'white',
                                    }}
                                >
                                    Resend
                                </button>
                            </Grid>                           
                            <Grid item xs={4} md={4}>
                                <button
                                    onClick={handleBack}
                                    className="backButton"
                                    style={{
                                        width: '100%',
                                        padding: '15px',
                                        fontSize: '15px',
                                    }}
                                >
                                   Cancel
                                </button>
                            </Grid>
                        </Grid>
                    </ValidatorForm>
                </div>
            )}
        </>
    )
}

export default VTap
